import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/arrow-left.svg'
import _imports_1 from '@/assets/wikidata.png'
import _imports_2 from '@/assets/external-link-blue.svg'


const _hoisted_1 = ["role"]
const _hoisted_2 = {
  href: "javascript:void(0)",
  class: "back-btn"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Back Button"
}, null, -1)
const _hoisted_4 = { class: "entity-details" }
const _hoisted_5 = { class: "entity-main-img" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["href", "title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "attribution-image",
  src: _imports_1
}, null, -1)
const _hoisted_9 = {
  key: 2,
  style: {"height":"250px","width":"100%"}
}
const _hoisted_10 = { class: "entity-main-title" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "entity-source-list" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "attribution-image",
  src: _imports_1
}
const _hoisted_15 = {
  key: 1,
  class: "attribution-container"
}
const _hoisted_16 = { class: "legend-icon" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"26px"} }, null, -1)
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "search-info-section" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "view-more-properties" }
const _hoisted_22 = {
  key: 1,
  class: "property-group"
}
const _hoisted_23 = { class: "info-title wrap-text" }
const _hoisted_24 = { class: "details-box" }
const _hoisted_25 = { class: "attribution-container" }
const _hoisted_26 = { class: "legend-icon" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"26px"} }, null, -1)
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "property-group" }
const _hoisted_30 = { class: "info-title wrap-text" }
const _hoisted_31 = { class: "details-box" }
const _hoisted_32 = {
  key: 0,
  class: "property-group"
}
const _hoisted_33 = { class: "info-title wrap-text" }
const _hoisted_34 = {
  key: 0,
  class: "details-box attribution-container"
}
const _hoisted_35 = ["href", "title"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  class: "attribution-image",
  src: _imports_1
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "attribution-container"
}
const _hoisted_39 = { class: "legend-icon" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"26px"} }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "property-group"
}
const _hoisted_42 = { class: "info-title wrap-text" }
const _hoisted_43 = {
  key: 0,
  class: "details-box"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_47 = { key: 3 }
const _hoisted_48 = {
  key: 0,
  class: "attribution-container"
}
const _hoisted_49 = { class: "legend-icon" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-right":"26px"} }, null, -1)
const _hoisted_51 = ["href"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_53 = {
  key: 4,
  style: {"height":"200px","width":"100%"}
}
const _hoisted_54 = { class: "property-group" }
const _hoisted_55 = { class: "info-title wrap-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatasetFilterWarning = _resolveComponent("DatasetFilterWarning")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_PersonDetailsCard = _resolveComponent("PersonDetailsCard")!
  const _component_AnnotationTargetCard = _resolveComponent("AnnotationTargetCard")!
  const _component_ResearchSpaceButton = _resolveComponent("ResearchSpaceButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["site-section", {
            'third-level-timeline': _ctx.isLastEntity && !_ctx.isAnnotationView && _ctx.timelineState == 'full',
            'third-level-partial-timeline': _ctx.isLastEntity && !_ctx.isAnnotationView && _ctx.timelineState == 'partial',
            'third-level-no-timeline': _ctx.isLastEntity && !_ctx.isAnnotationView && _ctx.timelineState == 'none',
            'annotation-view-space': _ctx.isAnnotationView,
        }]),
    role: (_ctx.isLastEntity || _ctx.isAnnotationView)  ? undefined : 'main'
  }, [
    (!_ctx.hideBackButton)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header-btn-block",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update', {})))
        }, [
          _createElementVNode("a", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("ViewMoreDetailsView.back")), 1)
          ])
        ], 512)), [
          [_vShow, !_ctx.isLastEntity]
        ])
      : _createCommentVNode("", true),
    (!_ctx.isLastEntity && _ctx.datasetsToHide.length > 0)
      ? (_openBlock(), _createBlock(_component_DatasetFilterWarning, {
          key: 1,
          initialSwitchValue: _ctx.disableDatasetFilters,
          onDatasetFilterUpdate: _cache[1] || (_cache[1] = (update) => { _ctx.$emit('datasetFilterUpdate', update) })
        }, null, 8, ["initialSwitchValue"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (
                        !(
                            _ctx.data.mainEntityInfo.type ==
                                'http://www.cidoc-crm.org/cidoc-crm/E53_Place' &&
                            _ctx.mainEntityPlaceCoords != null
                        )
                    )
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "img-fluid",
              src: 
                        _ctx.data.mainEntityInfo.image ||
                        'https://www.slntechnologies.com/wp-content/uploads/2017/08/ef3-placeholder-image.jpg'
                    ,
              alt: 
                        (_ctx.data.mainEntityInfo.typeLabel ?? _ctx.data.mainEntityInfo.type)  + ' icon'
                    
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (
                        _ctx.data.mainEntityInfo.hasOwnProperty(
                            'imageWikidataAttribution',
                        )
                    )
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "wikidata-attribution",
              href: _ctx.data.mainEntityInfo.imageWikidataAttribution,
              target: "_blank",
              title: _ctx.data.mainEntityInfo.imageName
            }, [
              _hoisted_8,
              _createTextVNode(" Wikidata ")
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        (
                        _ctx.data.mainEntityInfo.type ==
                            'http://www.cidoc-crm.org/cidoc-crm/E53_Place' &&
                        _ctx.mainEntityPlaceCoords != null
                    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_l_map, {
                ref: "map",
                zoom: _ctx.zoom,
                "onUpdate:zoom": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.zoom) = $event)),
                center: _ctx.mainEntityPlaceCoords
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_l_tile_layer, {
                    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
                    "layer-type": "base",
                    attribution: "Tiles © Esri"
                  }),
                  _createVNode(_component_l_marker, { "lat-lng": _ctx.mainEntityPlaceCoords }, null, 8, ["lat-lng"])
                ]),
                _: 1
              }, 8, ["zoom", "center"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h2", {
          title: 
                        _ctx.data.mainEntityInfo.resourceLabel ??
                        _ctx.data.mainEntityInfo.resource
                    
        }, _toDisplayString(_ctx.data.mainEntityInfo.resourceLabel ??
                        _ctx.data.mainEntityInfo.resource), 9, _hoisted_11),
        _createElementVNode("h4", null, _toDisplayString(_ctx.data.mainEntityInfo.typeLabel), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("ViewMoreDetailsView.sources")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasets, (dataset, datasetUri) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "source-list",
            key: datasetUri
          }, [
            (_ctx.disableDatasetFilters || _ctx.datasetsToDisplay.includes(datasetUri))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (dataset.legendIcon == 'WD')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(dataset.legendIcon), 1),
                        _hoisted_17
                      ])),
                  _createElementVNode("span", {
                    class: "predicate-text",
                    title: dataset.name ?? datasetUri
                  }, _toDisplayString(dataset.name ?? datasetUri), 9, _hoisted_18)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, !_ctx.isLastEntity]
    ]),
    _createElementVNode("ul", _hoisted_19, [
      (!_ctx.isLastEntity)
        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
            _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t("ViewMoreDetailsView.properties")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLastEntity)
        ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
            _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t("ViewMoreDetailsView.sources")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasets, (dataset, datasetUri) => {
              return (_openBlock(), _createElementBlock("div", { key: datasetUri }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(dataset.legendIcon), 1),
                    _hoisted_27
                  ]),
                  _createElementVNode("span", {
                    class: "predicate-text",
                    title: dataset.name ?? datasetUri
                  }, _toDisplayString(dataset.name ?? datasetUri), 9, _hoisted_28)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_29, [
        _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.$t("ViewMoreDetailsView.type")), 1),
        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.data.mainEntityInfo.typeLabel), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPredicates, (predicate, predicateIndex) => {
        return (_openBlock(), _createElementBlock("li", { key: predicateIndex }, [
          (!predicate.objectIsURI)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("h4", _hoisted_33, _toDisplayString(predicate.predicate), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data
                            .mainEntityInfo.outgoing, (outgoingPred, entityIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "data-property",
                    key: entityIndex
                  }, [
                    (
                                (_ctx.getLabel(outgoingPred.predicateLabel) ??
                                    _ctx.getLabel(outgoingPred.predicate)) ==
                                predicate.predicate
                                && (_ctx.disableDatasetFilters || _ctx.datasetsToDisplay.includes(outgoingPred.graph))
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (
                                    outgoingPred.hasOwnProperty(
                                        'wikidataAttribution',
                                    )
                                )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "attribution-container",
                                href: outgoingPred.wikidataAttribution,
                                target: "_blank",
                                title: outgoingPred.wikidataAttribution
                              }, _hoisted_37, 8, _hoisted_35))
                            : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.datasets[outgoingPred.graph].legendIcon), 1),
                                _hoisted_40
                              ])),
                          _createElementVNode("span", {
                            class: _normalizeClass({
                                    'wrap-text':
                                        outgoingPred.predicate !== 'has note',
                                    'predicate-text': true,
                                })
                          }, _toDisplayString(outgoingPred.objectLabel ??
                                    outgoingPred.object), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPredicates, (predicate, predicateIndex) => {
        return (_openBlock(), _createElementBlock("li", { key: predicateIndex }, [
          (predicate.objectIsURI)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("h4", _hoisted_42, _toDisplayString(predicate.predicate), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data
                            .mainEntityInfo.outgoing, (outgoingPred, entityIndex) => {
                  return (_openBlock(), _createElementBlock("div", { key: entityIndex }, [
                    (
                                (_ctx.getLabel(outgoingPred.predicateLabel) ??
                                    _ctx.getLabel(outgoingPred.predicate)) ==
                                predicate.predicate
                                && (_ctx.disableDatasetFilters || _ctx.datasetsToDisplay.includes(outgoingPred.graph))
                            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          (Array.isArray(outgoingPred.object))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outgoingPred.object, (predArrayItem, predArrayIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: predArrayIndex,
                                    class: "details-box"
                                  }, [
                                    _createElementVNode("a", {
                                      class: "wrap-text",
                                      href: _ctx.getExternalUrl(predArrayItem.uri),
                                      target: "_blank"
                                    }, [
                                      _createTextVNode(_toDisplayString(predArrayItem.label ??
                                            predArrayItem.uri) + " ", 1),
                                      _hoisted_46
                                    ], 8, _hoisted_45)
                                  ]))
                                }), 128))
                              ]))
                            : (
                                    outgoingPred.type ==
                                    'http://www.cidoc-crm.org/cidoc-crm/E21_Person'
                                )
                              ? (_openBlock(), _createBlock(_component_PersonDetailsCard, {
                                  key: 1,
                                  "datasets-to-display": _ctx.datasetsToDisplay,
                                  "disable-dataset-filters": _ctx.disableDatasetFilters,
                                  person: outgoingPred,
                                  legendIcon: outgoingPred.hasOwnProperty('graph') ? _ctx.datasets[outgoingPred.graph].legendIcon : ''
                                }, null, 8, ["datasets-to-display", "disable-dataset-filters", "person", "legendIcon"]))
                              : (outgoingPred.nonRsURI)
                                ? (_openBlock(), _createBlock(_component_AnnotationTargetCard, {
                                    key: 2,
                                    target: outgoingPred.object,
                                    image: outgoingPred.image,
                                    title: 
                                    outgoingPred.objectLabel ??
                                    outgoingPred.object
                                
                                  }, null, 8, ["target", "image", "title"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    (outgoingPred.hasOwnProperty('graph'))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.datasets[outgoingPred.graph].legendIcon), 1),
                                          _hoisted_50
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("a", {
                                      class: "wrap-text predicate-text",
                                      href: _ctx.getExternalUrl(outgoingPred.object),
                                      target: "_blank"
                                    }, [
                                      _createTextVNode(_toDisplayString(outgoingPred.objectLabel ??
                                        outgoingPred.object) + " ", 1),
                                      _hoisted_52
                                    ], 8, _hoisted_51)
                                  ])),
                          (
                                    Object.getOwnPropertyDescriptor(
                                        outgoingPred,
                                        'coords',
                                    )
                                    && (_ctx.disableDatasetFilters || _ctx.datasetsToDisplay.includes(outgoingPred.coords.graph))
                                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createVNode(_component_l_map, {
                                  ref_for: true,
                                  ref: 'map-' + entityIndex,
                                  zoom: outgoingPred.zoom.object,
                                  "onUpdate:zoom": ($event: any) => ((outgoingPred.zoom.object) = $event),
                                  center: outgoingPred.coords.object,
                                  id: entityIndex
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_l_tile_layer, {
                                      url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
                                      "layer-type": "base",
                                      attribution: "Tiles © Esri"
                                    }),
                                    _createVNode(_component_l_marker, {
                                      "lat-lng": outgoingPred.coords.object
                                    }, null, 8, ["lat-lng"])
                                  ]),
                                  _: 2
                                }, 1032, ["zoom", "onUpdate:zoom", "center", "id"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("li", _hoisted_54, [
        _createElementVNode("h4", _hoisted_55, _toDisplayString(_ctx.$t("ViewMoreDetailsView.identifier")), 1),
        _createVNode(_component_ResearchSpaceButton, {
          resource: _ctx.data.mainEntityInfo.resource
        }, null, 8, ["resource"])
      ])
    ])
  ], 10, _hoisted_1))
}